import {PaginationResponse} from '@common/http/backend-response/pagination-response';
import {User} from '@ui/types/user';

export const CHANNEL_MODEL = 'channel';

export type ChannelContentItem<T = unknown> = T & {
  channelable_id?: number;
  channelable_order?: number;
};

export interface ChannelConfig {
  autoUpdateMethod?: string;
  autoUpdateProvider?: string;
  autoUpdateValue?: string | number | null;
  disablePagination?: boolean;
  disablePlayback?: boolean;
  restriction?: string | null;
  restrictionModelId?: 'urlParam' | number | null;
  contentModel: string;
  contentType: 'listAll' | 'manual' | 'autoUpdate';
  contentOrder: string;
  contentFormat?: string;
  nestedContentFormat?: string;
  // layout user selected manually, it's stored in a cookie and set as this
  // prop in channel controller so there are no mismatches during SSR
  selectedLayout?: string;
  layout: string;
  nestedLayout: string;
  hideTitle?: boolean;
  hideTitleWhenNested?: boolean;
  lockSlug?: boolean;
  preventDeletion?: boolean;
  actions?: {tooltip: string; icon: string; route: string}[];
  adminDescription?: string;
  paginationType?: 'infiniteScroll' | 'lengthAware' | 'simple';
  type_id?: number;
  album_type_id?: number;           // Type principal (e.g., 'music', 'podcast')
  album_subtype_id?: number;     // Sous-type basé sur le type sélectionné
  radio_seed_type?: 'artist' | 'genre' | null;
}

export interface Channel<T = ChannelContentItem> {
  id: number;
  name: string;
  internal: boolean;
  public: boolean;
  description?: string;
  type: string;
  slug: string;
  config: ChannelConfig;
  items?: T[];
  model_type: 'channel';
  items_count?: number;
  user?: User;
  user_id: number;
  updated_at?: string;
  restriction?: {id: number; name: string; model_type: string; display_name: string;};
  content?: PaginationResponse<T>;
}
